import { PanelLeftIcon } from 'lucide-react';
import type * as React from 'react';
import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/button/button';
import { useSidebar } from '@/shared/ui/sidebar/use-sidebar';

export function SidebarTrigger({ className, onClick, ...props }: React.ComponentProps<typeof Button>) {
  const { toggleSidebar } = useSidebar();

  return (
    <Button
      data-sidebar="trigger"
      data-slot="sidebar-trigger"
      variant="ghost"
      size="icon-sm"
      className={cn(className)}
      onClick={(event) => {
        onClick?.(event);
        toggleSidebar();
      }}
      {...props}
    >
      <PanelLeftIcon />
      <span className="sr-only">Toggle Sidebar</span>
    </Button>
  );
}
